var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2570",
    "data-name": "Groupe 2570",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113.664,
    height: 119.693,
    viewBox: "0 0 113.664 119.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2103",
    "data-name": "Rectangle 2103",
    width: 113.664,
    height: 119.693,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2570-2",
    "data-name": "Groupe 2570",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2950",
    "data-name": "Trac\\xE9 2950",
    d: "M81.01,112.293H10.27a2.883,2.883,0,0,1-2.87-2.87V38.683a2.868,2.868,0,0,0-2.86-2.87H2.86A2.868,2.868,0,0,0,0,38.683v73.6a7.14,7.14,0,0,0,2.22,5.18,7.1,7.1,0,0,0,5.18,2.22l73.61.01a2.868,2.868,0,0,0,2.86-2.87v-1.67a2.859,2.859,0,0,0-2.86-2.86m13.96-71.67a3.7,3.7,0,0,0-3.69,3.7v50.87a2.29,2.29,0,0,1-2.29,2.29H24.49a2.29,2.29,0,0,1-2.29-2.29v-64.5a2.288,2.288,0,0,1,2.29-2.28H59.24a3.7,3.7,0,0,0,0-7.4H22.2a7.6,7.6,0,0,0-7.4,7.4v69.07a7.59,7.59,0,0,0,7.4,7.4H91.27a7.59,7.59,0,0,0,7.4-7.4V44.323a3.7,3.7,0,0,0-3.7-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2951",
    "data-name": "Trac\\xE9 2951",
    d: "M85.709,0V7.35a14.32,14.32,0,0,0-6.656,8.8q9.318,0,9.318,9.9,0,10.186-10.244,10.186-10.071,0-10.07-12.1Q68.057,5.325,85.709,0M111,0V7.35a14.094,14.094,0,0,0-6.6,8.8q9.259,0,9.261,9.9,0,10.186-10.244,10.186-10.071,0-10.071-12.1Q93.349,5.382,111,0",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2952",
    "data-name": "Trac\\xE9 2952",
    d: "M98.67,44.323a3.7,3.7,0,1,1-3.7-3.7,3.7,3.7,0,0,1,3.7,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2953",
    "data-name": "Trac\\xE9 2953",
    d: "M62.93,24.713a3.7,3.7,0,1,1-3.69-3.7,3.7,3.7,0,0,1,3.69,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2954",
    "data-name": "Trac\\xE9 2954",
    d: "M36.14,53.083H77.46a3.7,3.7,0,1,0,0-7.4H36.14a3.7,3.7,0,0,0,0,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2955",
    "data-name": "Trac\\xE9 2955",
    d: "M77.46,59.253H36.14a3.7,3.7,0,0,0,0,7.4H77.46a3.7,3.7,0,1,0,0-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2956",
    "data-name": "Trac\\xE9 2956",
    d: "M56.49,72.813H36.14a3.7,3.7,0,1,0,0,7.4H56.49a3.7,3.7,0,0,0,0-7.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bd709a1d7bd7b3c1e5a60914850dec7f.svg";
export { ForwardRef as ReactComponent };